export default __webpack_public_path__ + "static/media/close-purple.303ee24a.svg";